import { t } from '@lingui/core/macro';

import type {
  KPINotificationType,
  PageMetaNotificationNameType,
} from '@/api/settings/settingsType';

type WebTrafficKPINameType =
  | 'web-traffic-total-visits'
  | 'web-traffic-target-visits'
  | 'web-traffic-engaged-companies'
  | 'web-traffic-pipeline-influenced'
  | 'web-traffic-closed-won-influenced';

export const webTrafficGoalKPIs = (): Partial<
  Record<PageMetaNotificationNameType, KPINotificationType<WebTrafficKPINameType>[]>
> => ({
  'web-traffic': [
    {
      value: 'web-traffic-total-visits',
      label: t`Total Visits`,
      allowsAudience: false,
    },
    {
      value: 'web-traffic-target-visits',
      label: t`Audience Visits`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-engaged-companies',
      label: t`Engaged Companies`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-pipeline-influenced',
      label: t`Pipeline Influence`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-closed-won-influenced',
      label: t`Closed Won Influence`,
      allowsAudience: true,
    },
  ],
});
